import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamRURU() {
  return (
    <div className={styles["declaration"]}>
      <h1>Заявление о соответствии требованиям для обучения и тестирования полевых сотрудников</h1>

      <p>
        С целью постоянного повышения качества обслуживания сторонних промоутеров на местах команда по обучению Международного отдела Xiaomi (далее именуемая «мы» или «наша компания») предоставляет обучающие курсы и сопутствующие тесты для сторонних промоутеров (далее — «обучающиеся»), назначенных поставщиками аутсорсинговых услуг. Целью обучения и тестирования является оптимизация содержания курсов и закрепление полученных знаний. Они не являются установлением каких-либо трудовых отношений или фактическим управленческим действием. Ниже представлено заявление, касающееся обучения и тестирования:
      </p>

      <ol>
        <li>
          <strong>Характер обучения и тестирования</strong><br/>
          Все обучающие курсы и тесты проводятся исключительно в целях обмена знаниями и направлены на систематизацию понимания обучающимися информации о продуктах, стандартах обслуживания и т. д. Результаты тестов отражают только степень усвоения обучающимися учебного материала и не используются в качестве основы для оценки эффективности их работы. Мы не обладаем полномочиями и не будем вмешиваться в процессы оценки эффективности, распределения заработной платы или другие кадровые вопросы, относящиеся к обучающимся и находящиеся в ведении поставщиков аутсорсинговых услуг.
        </li>
        <li>
          <strong>Разъяснение юридических отношений</strong><br/>
          Трудовые отношения между обучающимися и поставщиками аутсорсинговых услуг остаются неизменными в рамках данной программы обучения и тестирования. Между нашей компанией и обучающимися не существует трудовых отношений, и данная программа обучения и тестирования не создает де-факто трудовых отношений. Все трудовые права и обязательства остаются исключительно между поставщиками аутсорсинговых услуг и обучающимися.
        </li>
        <li>
          <strong>Использование результатов тестирования</strong><br/>
          Результаты тестов могут использоваться только в следующих целях:
          <ol type="1">
            <li>В качестве внутренней справочной информации для оптимизации и улучшения обучающих курсов;</li>
            <li>В качестве подтверждения профессиональной компетентности обучающихся, предоставляемого поставщикам аутсорсинговых услуг, с учетом их независимого суждения и добровольного решения;</li>
            <li>Результаты тестов не подлежат публичному раскрытию или передаче третьим сторонам.</li>
          </ol>
        </li>
      </ol>

      <p>
        Настоящее заявление вступает в силу с момента его публикации. Участие в программе обучения и тестирования означает признание и принятие данного заявления обучающимися. Наша компания оставляет за собой право толкования настоящего заявления и может разумным образом вносить в него изменения при условии, что такие изменения не будут изменять его нефинансовый и нетрудовой характер. При наличии расхождений или противоречий между версиями на разных языках приоритетной считается версия на английском языке.
      </p>

      <div className={styles["footer"]}>
        Команда по обучению Международного отдела Xiaomi<br/>
        Дата: {getLocalizedTime('ru-RU')}
      </div>
    </div>
  );
}